module.exports = "/fonts/ARIALLGTITL.woff?9c4e496c4d7b6b6cf31cf4129b518e7e";